import React from 'react';
import { ActivityStats } from 'types/interfaces/activity';
import './LivePulseDashboard.css';

interface LivePulseDashboardProps {
  stats: ActivityStats | undefined;
  isLoading: boolean;
  isConnected: boolean;
}

const formatStatNumber = (num: number): string => {
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}k`;
  }
  return String(num);
};

const LivePulseDashboard: React.FC<LivePulseDashboardProps> = ({
  stats,
  isLoading,
  isConnected,
}) => {
  return (
    <div className="live-pulse-dashboard">
      <div className="live-pulse-dashboard__indicator">
        <span
          className={`live-pulse-dashboard__dot${isConnected ? ' live-pulse-dashboard__dot--connected' : ' live-pulse-dashboard__dot--disconnected'}`}
        />
        <span className="live-pulse-dashboard__label">
          {isConnected ? 'Live' : 'Reconnecting'}
        </span>
      </div>

      <div className="live-pulse-dashboard__divider" />

      <div className="live-pulse-dashboard__stats">
        <div className="live-pulse-dashboard__stat">
          <span className="live-pulse-dashboard__stat-value">
            {isLoading ? '—' : formatStatNumber(stats?.tradesLastHour ?? 0)}
          </span>
          <span className="live-pulse-dashboard__stat-label">trades/hr</span>
        </div>

        <div className="live-pulse-dashboard__divider" />

        <div className="live-pulse-dashboard__stat">
          <span className="live-pulse-dashboard__stat-value">
            {isLoading ? '—' : formatStatNumber(stats?.packagesShippedToday ?? 0)}
          </span>
          <span className="live-pulse-dashboard__stat-label">shipped today</span>
        </div>

        <div className="live-pulse-dashboard__divider" />

        <div className="live-pulse-dashboard__stat">
          <span className="live-pulse-dashboard__stat-value">
            {isLoading ? '—' : formatStatNumber(stats?.cardsTradedThisWeek ?? 0)}
          </span>
          <span className="live-pulse-dashboard__stat-label">cards/wk</span>
        </div>
      </div>
    </div>
  );
};

export default LivePulseDashboard;
